import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_REQUEST_MANAGER } from "../../config/config.json";
import { decryptStorage } from 'utils/utils';

const prepareHeaders = () => (headers) => {
    headers.set('content-type', 'application/json');
    headers.set('accept', '*/*');
    headers.set('Accept-Encoding', 'gzip, deflate, br');
    headers.set('Connection', 'keep-alive');

    const token = decryptStorage(localStorage.getItem("tokenSecurity"));
    if (token) headers.set('Authorization', `Bearer ${token}`);

    return headers;
};

const baseQuery = fetchBaseQuery({
    baseUrl: API_REQUEST_MANAGER,
    extraOptions: { timeout: 30000 },
    prepareHeaders: prepareHeaders(true), // Por defecto, se incluye la autorización
});

export const microServiceRequestManager = createApi({
    reducerPath: 'microServiceRequestManager',
    baseQuery,
    endpoints: () => ({})
});